export const CAROUSEL_CONFIG_HOME = 'home';
export const CAROUSEL_CONFIG_DEFAULT = '';
export const CAROUSEL_DEFAULT_SORT_ORDER = 'desc';
